module.exports = __webpack_public_path__ + "static/media/1 26 lave.7abbb3df.mp3";